import React from 'react';
import { Center } from '@chakra-ui/react';
import { WhiteBox } from 'components/shared/WhiteBox';

export const Container = React.memo(({ children }) => {
  return (
    <Center mb={{ base: 5, md: 8 }} ml={4} mr={4}>
      <WhiteBox>{children}</WhiteBox>
    </Center>
  );
});
